import { useId } from "react";

import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { AvatarList } from "@tudigo-monorepo/web-tudigo-components";

import { useGetClubV2UsingIdPathParams } from "../../../shared-internal/hooks/use-get-club-v2-using-id-path-params";

type ClubAvatarLeadersProps = {
  countAvatarDisplayed?: number;
};

export const ClubLeadersStats = () => {
  const club = useGetClubV2UsingIdPathParams();

  const { t } = useTranslation();

  if (!club) {
    return;
  }

  return (
    <p className="text-primary text-sm">
      {t("page_club.club_membership_component.club_leaders.paragraph", {
        followersCount: club.statistics.followersCount,
      })}
    </p>
  );
};

export const ClubLeadersAvatar = ({
  countAvatarDisplayed = 3,
}: ClubAvatarLeadersProps) => {
  const club = useGetClubV2UsingIdPathParams();
  const randId = useId();
  const randomId = `${randId}-club-leaders-avatar`;

  if (!club || !club?.leaders) {
    return;
  }

  const avatars = club.leaders.map((leader) => ({
    id: leader.id || `leader-${randomId}`,
    url: leader.profileImage?.url ?? "",
    alt: `${leader.firstName} ${leader.lastName}`,
  }));

  return (
    <AvatarList
      avatars={avatars}
      maxDisplayed={countAvatarDisplayed}
      avatarSize="md"
    />
  );
};
